import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=8883e69e"
import script from "./option-group.vue?vue&type=script&lang=js"
export * from "./option-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports